import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Logo from "../../images/logo.png";
import Head from "../../layout/head/Head";
import AuthFooter from "./AuthFooter";
import {
  BackTo,
  Block,
  BlockContent,
  BlockDes,
  BlockHead,
  BlockTitle,
  Icon,
  PreviewCard,
} from "../../components/Component";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../components/Component";
import { Alert, Row, Spinner } from "reactstrap";
import { OptionCardLink } from "../dashboard_pages/components/cards/CardLinks";
import { useSelector, useDispatch } from "react-redux";
import * as app_consts from "../../constants/react_app_consts";
import {
  fail_send_otp_option,
  loading_send_otp_option,
  reset_send_otp_option,
  success_send_otp_option,
} from "../../reducers/website_reducers/auth/send_otp_option_Slice";
import { SEND_OTP_AUTH_API } from "../../api/api_data";
import {
  SENT_OTP_AUTH_ERR_MSG,
  SENT_OTP_AUTH_SUCESS_MSG,
} from "../../constants/success_error_messages_consts";
import { website_actions_helper } from "../../actions/actions_helper";

const initialState = { username: "", send_otp_type: "" };
const initialHideState = { type: "", status: false };

const SendOTP = ({ user_details }) => {
  const [errorVal, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(initialState);
  const [page_data, setPageData] = useState(user_details);
  const [hideOption, setHideOption] = useState(initialHideState);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = () => {
    setError("");
    setHideOption({
      ...hideOption,
      ["type"]: formData.send_otp_type.toLowerCase(),
      ["status"]: true,
    });

    dispatch(
      website_actions_helper(
        loading_send_otp_option,
        success_send_otp_option,
        fail_send_otp_option,
        SENT_OTP_AUTH_ERR_MSG,
        SENT_OTP_AUTH_SUCESS_MSG,
        app_consts.POST,
        SEND_OTP_AUTH_API,
        formData
      )
    );
  };

  // Watch OTP request status
  const send_otp_req = useSelector(
    (state) => state.send_otp_option.send_otp_option
  );

  useEffect(() => {
    if (send_otp_req.status !== app_consts.IDLE)
    {
      if (send_otp_req.status === app_consts.LOADING)
      {
        setError("");
        setLoading(true);
      } else
      {
        setLoading(false);
        if (send_otp_req.status === app_consts.FAIL)
        {
          setError(send_otp_req.message);
          setHideOption(initialHideState);
          dispatch(reset_send_otp_option());
        } else if (send_otp_req.status === app_consts.SUCCESS)
        {
          navigate(`/auth/verify_otp/${user_details.username}`);
        }
      }
    }
  }, [send_otp_req]);

  // Load initial user data
  useEffect(() => {
    setFormData({ ...formData, ["username"]: user_details.username });
    setPageData(user_details);
  }, []);

  return (
    <>
      <Head title="Send OTP" />
      <Block className="nk-block-middle nk-auth-body wide-xs">
        <motion.div
          className="brand-logo pb-4 text-center"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Link to={`${process.env.PUBLIC_URL}/`} className="logo-link">
            <img
              className="logo-light logo-img logo-img-website"
              src={Logo}
              alt="logo"
            />
            <img
              className="logo-dark logo-img logo-img-website"
              src={Logo}
              alt="logo-dark"
            />
          </Link>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.4 }}
        >
          <PreviewCard className="card-bordered" bodyClass="card-inner-lg">
            <BlockHead>
              <BlockContent>
                <BackTo link="/auth/signin" icon="arrow-left">
                  Change Username
                </BackTo>
                <BlockTitle tag="h4">
                  Sign-In{" "}
                  <strong className="text-primary small">
                    {page_data.first_name
                      ? ` / ${page_data.first_name} ${page_data.surname}`
                      : ""}
                  </strong>
                </BlockTitle>
                <BlockDes>
                  <p>Select where to receive your One Time Login Passcode.</p>
                </BlockDes>
              </BlockContent>
            </BlockHead>

            {errorVal && (
              <motion.div
                className="mb-3"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
              >
                <Alert color="danger" className="alert-icon">
                  <Icon name="alert-circle" /> {errorVal}{" "}
                </Alert>
              </motion.div>
            )}

            <form
              className="is-alter"
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <Row>
                {page_data ? (
                  <>
                    {/* Phone - SMS */}
                    {page_data.phone_number &&
                      (hideOption.status
                        ? hideOption.type ===
                        app_consts.SEND_OTP_MOBILE.toLowerCase()
                        : true) && (
                        <OptionCardLink
                          linkHeading="SMS"
                          link_name={app_consts.SEND_OTP_MOBILE.toLowerCase()}
                          linkValue={`+${page_data.phone_number}`}
                          setFormData={setFormData}
                          formData={formData}
                        />
                      )}

                    {/* Phone - WhatsApp */}
                    {/* {page_data.phone_number &&
                      (hideOption.status
                        ? hideOption.type ===
                        app_consts.SEND_OTP_MOBILE.toLowerCase()
                        : true) && (
                        <OptionCardLink
                          linkHeading="Whatsapp"
                          link_name={app_consts.SEND_OTP_WHATSAPP.toLowerCase()}
                          linkValue={`+${page_data.phone_number}`}
                          setFormData={setFormData}
                          formData={formData}
                        />
                      )} */}

                    {/* Email */}
                    {page_data.email_address &&
                      (hideOption.status
                        ? hideOption.type ===
                        app_consts.SEND_OTP_EMAIL.toLowerCase()
                        : true) && (
                        <OptionCardLink
                          linkHeading="Email Address"
                          link_name={app_consts.SEND_OTP_EMAIL.toLowerCase()}
                          linkValue={page_data.email_address}
                          setFormData={setFormData}
                          setHideOption={setHideOption}
                          formData={formData}
                        />
                      )}
                  </>
                ) : (
                  ""
                )}
              </Row>

              <div className="form-group mt-4">
                <Button
                  onClick={handleSubmit}
                  size="lg"
                  className="btn-block"
                  type="submit"
                  color="primary"
                  disabled={loading ? loading : !formData.send_otp_type}
                >
                  {loading ? (
                    <Spinner size="sm" color="light" />
                  ) : (
                    "Send Passcode"
                  )}
                </Button>
              </div>
            </form>
          </PreviewCard>
        </motion.div>
      </Block>

      {/* Keep footer at bottom */}
      <AuthFooter />
    </>
  );
};

export default SendOTP;
